import { configureStore } from "@reduxjs/toolkit";
import logger from "redux-logger";
import { authReducer, forgetPasswordReducer, resetPasswordReducer } from "./features/auth/authSlice";
import { appVersionReducer, languageReducer, updateAppVersionReducer } from "./features/settings/settingSlice";
import { deleteNotificationSlice, notifications } from "./features/notifications/notificationSlice";
import { dashboardReducer } from "./features/dashboard/dashboardSlice";
import { invoiceReducer } from "./features/invoice/invoiceSlice";
import { profileDetails } from "./features/profile/profileSlice";
import { changePasswordDetails } from "./features/changePassword/changePasswordSlice";


export const store = configureStore({
  reducer: {
    auth: authReducer,
    forgetPasswordSlice: forgetPasswordReducer,
    resetPasswordSlice: resetPasswordReducer,
    languageSlice: languageReducer,
    appVersionReducer:appVersionReducer,
    updateAppVersionSlice:updateAppVersionReducer,
    notificationsSlice: notifications,
    deleteNotificationSlice: deleteNotificationSlice,
    dashboardSlice: dashboardReducer,
    invoiceSlice: invoiceReducer,
    profileDetailsSlice: profileDetails,
    changePasswordDetailsSlice:changePasswordDetails
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }).concat(logger as any),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
